import { getDashboardData, exportData } from './../api';
import { dashboardSoldToList, shipTo } from '../../../../api/index';
const dashboard = {
  namespaced: true,
  state: {
    successCode: 200,
    dashboardData: null,
    soldToListData: [],
    shipToListData: [],
    exportData: null
  },
  mutations: {
    GET_DASHBOARD_DATA(state, data) {
      state.dashboardData = data;
    },
    GET_SOLDTO_LIST(state, data) {
      state.soldToListData = data;
    },
    GET_SHIPTO_LIST(state, data) {
      state.shipToListData = data;
    },
    GET_EXPORT_DATA(state, data) {
      state.exportData = data;
    }
  },
  actions: {
    // 查询事件
    async getDashboardData({ commit }, obj) {
      let resp = await getDashboardData(obj);
      commit('GET_DASHBOARD_DATA', resp);
    },
    // soldTo下拉列表
    async dashboardSoldToList({ commit }, obj) {
      let resp = await dashboardSoldToList(obj);
      commit('GET_SOLDTO_LIST', resp);
    },
    // shipTo下拉列表
    async shipTo({ commit }, obj) {
      let resp = await shipTo(obj);
      commit('GET_SHIPTO_LIST', resp);
    },
    // 导出
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('GET_EXPORT_DATA', resp);
    }
  }
}
export default dashboard



// WEBPACK FOOTER //
// ./src/page/report/dashboard/store/dashboard.store.js